var map = {
	"./education.png": 852,
	"./hunger.jpg": 153,
	"./medical.jpg": 767,
	"./testimonial1.jpg": 614,
	"./testimonial2.jpg": 729,
	"./testimonial3.jpg": 676,
	"./water.jpg": 243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;